export default "__VITE_ASSET__c7841d2d__"